import PageManager from "../page-manager";
import { cloneDeep } from 'lodash';

export default class Seof extends PageManager {
    constructor(context) {
        super(context);
        this.$overlay = $('#main-content .loadingOverlay');
    }

    onReady() {
        $('body').addClass('super-easy-order-form');

        this.loadProducts();
    }

    async loadProducts() {
        this.$overlay.show();
        const ids = this.context.subcategoryIds;
        let data = new Map();

        fetch('/graphql', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.context.settings.storefront_api.token}`
            },
            body: JSON.stringify({
                query: `
                query MyFirstQuery {
                site {
                    category(entityId: ${this.context.categoryId}) {
                        id
                        entityId
                        name
                        products(first: 50) {
                            edges {
                              node {
                                entityId
                                name
                                sku
                                path
                                warranty
                                inventory {
                                    aggregated {
                                        availableToSell
                                        warningLevel
                                    }
                                    isInStock
                                }
                                defaultImage {
                                  url(width: 200)
                                }
                                prices {
                                  price {
                                    ...PriceFields
                                  }
                                  basePrice {
                                    ...PriceFields
                                  }
                                  salePrice {
                                    ...PriceFields
                                  }
                                  bulkPricing {
                                    ... BulkPricingFields
                                  }
                                }
                              }
                            }
                        }
                    }
                  }
                }
                fragment PriceFields on Money {
                  value
                  currencyCode
                }
                fragment BulkPricingFields on BulkPricingTier {
                  minimumQuantity
                  maximumQuantity
                  ... on BulkPricingFixedPriceDiscount {
                    price
                  }
                  ... on BulkPricingRelativePriceDiscount {
                    priceAdjustment
                  }
                  ... on BulkPricingPercentageDiscount {
                    percentOff
                  }
                }
                `
            }),
        })
        .then(res => res.json())
        .then(json => {
            for (let edge of json.data.site.category.products.edges) {
                data.set(edge.node.sku, edge.node);
            }

            console.log(data)
            this.$overlay.hide();
            this.productData = data;
            this.initApp();
        })
    }

    initApp() {
        const self = this;
        const configJson = window.seof_backup_json;
        const productsSku = Object.keys(configJson.items);
        let groupIdIndexMap = new Map();
        let groups = cloneDeep(configJson.panel_groups);
        for (let index in groups) {
            let group = groups[index];
            group.sku_list = [];
            groupIdIndexMap.set(group.group_id, index);
        }

        for (let sku of productsSku) {
            let values = configJson.items[sku];
            let groupIndex = groupIdIndexMap.get(values["panel_group"]);
            groups[groupIndex]["sku_list"].push(sku);
        }

        let state = {};
        if (window.localStorage.getItem('qtyState')) {
            state = window.localStorage.getItem('qtyState');
            state = JSON.parse(state);
        }
        let productsQty = {};
        for (let sku of productsSku) {
            productsQty[sku] = 0;
            if (sku in state) {
                productsQty[sku] = state[sku];
            }
            if (self.productData.get(sku).warranty) {
                let warrantyArray = JSON.parse(self.productData.get(sku).warranty);
                if ("notAvailableInCanada" in warrantyArray) {
                    if (warrantyArray["notAvailableInCanada"] == true) {
                        productsQty[sku] = 0;
                    }
                }
            }
        }

        const App = {
            data() {
                return {
                    active: 1,
                    completed: [],
                    steps: configJson.steps,
                    items: configJson.items, // items config defined in json
                    groups: groups, // product group defined in json
                    products: self.productData, // category product data from bc
                    productsSku: productsSku, // list of all skus from json
                    productsQty: productsQty,
                    stepOneLabels: configJson.steps.stepOne.body.labels,
                    stepTwoButtons: configJson.steps.stepTwo.body.buttons,
                    variableA: 0,
                    variableB: 0,
                    icons: ["key_item", "included_in_kit", "kid_favorite", "volunteer_favorite", "director_favorite"],
                    keyItemsAdded: 0,
                    suggestedItemsAdded: 0,
                }
            },
            created() {
                window.addEventListener('beforeunload', this.saveQtyState);
            },
            computed: {
                isSimpleForm() {
                    return "isSimpleSeof" in configJson && configJson["isSimpleSeof"];
                },
                currencyIsCanada() {
                    return self.context.currency_selector.active_currency_code == "CAD";
                },
                stepOnePrompt() {
                    return `${this.variableA} ${this.stepOneLabels[0]}, ${this.variableB} ${this.stepOneLabels[1]}`;
                },
                stepOneActive() {
                    return this.active === 1;
                },
                stepTwoPrompt() {
                    let prompt = '';
                    if (this.keyItemsAdded) {
                        prompt += 'Key items added';
                    }
                    if (this.suggestedItemsAdded) {
                        prompt += 'Suggested items added';
                    }
                    return prompt;
                },
                stepTwoActive() {
                    return this.active === 2;
                },
                stepThreeActive() {
                    return this.active === 3;
                },
                showEditStepOne() {
                    return this.completed.includes(1);
                },
                showEditStepTwo() {
                    return this.completed.includes(2);
                },
                showEditStepThree() {
                    return this.completed.includes(3);
                },
                productsTotal() {
                    let total = {};
                    for (let sku of this.productsSku) {
                        let price = this.getProductFinalPrice(sku);
                        let qty = this.productsQty[sku];
                        total[sku] = price * qty;
                    }
                    return total;
                },
                orderTotal() {
                    let total = 0;
                    for (let sku of this.productsSku) {
                        let price = this.getProductFinalPrice(sku);
                        let qty = this.productsQty[sku];
                        if (qty && qty > 0) {
                            total += price * qty;
                        }
                    }
                    return total;
                }
            },
            methods: {
                saveQtyState (evt) {
                    window.localStorage.setItem('qtyState', JSON.stringify(this.productsQty));
                },
                validateNumber(event) {
                    let keyCode = event.keyCode;
                    if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode === 46) {
                        event.preventDefault();
                    }
                },
                formatCurrency(number) {
                    return new Intl.NumberFormat('en-US', { style: 'currency', currency: self.context.currency_selector.active_currency_code }).format(number);
                },
                setActive(step) {
                    this.active = step;
                },
                stepOneSubmit() {
                    this.active = 2;
                    this.completed.push(1);
                },
                addKeyItems() {
                    this.keyItemsAdded = 1;
                    this.suggestedItemsAdded = 0;
                    this.active = 3;
                    this.completed.push(2);

                    for (let sku of this.productsSku) {
                        const item = this.items[sku];
                        if (item && "product_type" in item && item["product_type"].includes('key_item')) {
                            let qty = this.getSuggestedQty(sku);
                            this.productsQty[sku] = qty;
                        } else {
                            this.productsQty[sku] = 0;
                        }
                    }
                },
                addSuggestedItems() {
                    this.keyItemsAdded = 0;
                    this.suggestedItemsAdded = 1;
                    this.active = 3;
                    this.completed.push(2);

                    for (let sku of this.productsSku) {
                        let qty = this.getSuggestedQty(sku);
                        if (qty && qty > 0) {
                            this.productsQty[sku] = qty;
                        } else {
                            this.productsQty[sku] = 0;
                        }
                    }
                },
                stepTwoSubmit() {
                    this.active = 3;
                    this.completed.push(2);
                },
                iconHtml(type) {
                    let html = '';
                    switch (type) {
                        case "key_item":
                            html = '<div class="icon-background ' + type + '">\
                                <i class="icon"><svg><use xlink:href="#icon-door-key" /></svg></i>\
                                <div class="tooltip">Key Item</div>\
                                </div>';
                            html += '<div class="icon-type">Key<br>Item</div>'
                            break;
                        case "included_in_kit":
                            html = '<div class="icon-background ' + type + '">\
                                <i class="icon"><svg><use xlink:href="#icon-package" /></svg></i>\
                                <div class="tooltip">Included in Kit</div>\
                                </div>';
                            html += '<div class="icon-type">Included<br>in Kit</div>'
                            break;
                        case "kid_favorite":
                            html = '<div class="icon-background ' + type + '">\
                                <span class="icon-text">KF</span>\
                                <div class="tooltip">Kid Favorite</div>\
                                </div>';
                            html += '<div class="icon-type">Kid<br>Favorite</div>'
                            break;
                        case "volunteer_favorite":
                            html = '<div class="icon-background ' + type + '">\
                                <span class="icon-text">VF</span>\
                                <div class="tooltip">Volunteer Favorite</div>\
                                </div>';
                            html += '<div class="icon-type">Volunteer<br>Favorite</div>'
                            break;
                        case "director_favorite":
                            html = '<div class="icon-background ' + type + '">\
                                <span class="icon-text">DF</span>\
                                <div class="tooltip">Director Favorite</div>\
                                </div>';
                            html += '<div class="icon-type">Director<br>Favorite</div>'
                            break;
                    }
                    return html;
                },
                getProductUrl(sku) {
                    return this.products.get(sku).path + "?referer=seof";
                },
                getProductId(sku) {
                    return this.products.get(sku).entityId;
                },
                getProductInStock(sku) {
                    return this.products.get(sku).inventory.isInStock;
                },
                getProductImage(sku) {
                    return this.products.get(sku).defaultImage.url;
                },
                getProductName(sku) {
                    return this.products.get(sku).name;
                },
                getProductIcon(sku) {
                    let html = '';
                    const item = this.items[sku];
                    if (item && "product_type" in item) {
                        for (let type of item["product_type"]) {
                            html += this.iconHtml(type);
                        }
                    }
                    return html;
                },
                getSuggestedQty(sku) {
                    let result = 0;
                    if (this.items[sku]) {
                        const formula = this.items[sku].formula;
                        let replacea = formula.replace(/(?<=\()a/i, 'this.variableA');
                        let replaceb = replacea.replace(/(?<=\()b|(?<=\+)b/i, 'this.variableB');
                        result = eval(replaceb);
                    }
                    return result;
                },
                notAvailableCanada(sku) {
                    let result = false;
                    if (this.products.get(sku).warranty) {
                        let warrantyArray = JSON.parse(this.products.get(sku).warranty);
                        if ("notAvailableInCanada" in warrantyArray) {
                            if (warrantyArray["notAvailableInCanada"] == true) {
                                result = true;
                            }
                        }
                    }
                    return result;
                },
                calculatePriceFromBulk(originPrice, bulk) {
                    let result = originPrice;
                    if (bulk.percentOff) {
                        result = originPrice * (1 - bulk.percentOff / 100);
                    }
                    if (bulk.price) {
                        result = bulk.price;
                    }
                    if (bulk.priceAdjustment) {
                        result = originPrice - bulk.priceAdjustment;
                    }
                    return result;
                },
                getProductDisplayPrice(sku) {
                    const prices = this.products.get(sku).prices;
                    let html = '';
                    let price = prices.price.value;
                    let basePrice = prices.basePrice.value;
                    let salePrice = basePrice;
                    html += '<span class="mobile">Price Each:</span>';
                    if (prices.bulkPricing.length > 0) {
                        let [minPrice, maxPrice] = [price, price];
                        for (let bulk of prices.bulkPricing) {
                            minPrice = Math.min(minPrice, this.calculatePriceFromBulk(price, bulk));
                            maxPrice = Math.max(maxPrice, this.calculatePriceFromBulk(price, bulk));
                        }
                        html += `${this.formatCurrency(minPrice)} - ${this.formatCurrency(maxPrice)}`;
                    } else if (prices.salePrice) {
                        salePrice = prices.salePrice.value;
                        html += `<span class="price price--non-sale">${this.formatCurrency(basePrice)}</span>`;
                        html += `${this.formatCurrency(salePrice)}`;
                    } else {
                        html += `${this.formatCurrency(price)}`;
                    }

                    if (this.products.get(sku).warranty) {
                        let warrantyArray = JSON.parse(this.products.get(sku).warranty);
                        if ("howPackaged" in warrantyArray) {
                            let packageInfo = warrantyArray["howPackaged"];
                            html += `<span class="package-info">${packageInfo}</span>`;
                        }
                    }

                    return html;
                },
                getProductFinalPrice(sku) {
                    const prices = this.products.get(sku).prices;
                    const price = prices.price.value;
                    let result = price;
                    if (prices.bulkPricing.length > 0) {
                        const qty = this.productsQty[sku];
                        for (let bulk of prices.bulkPricing) {
                            if (qty >= bulk.minimumQuantity && (qty <= bulk.maximumQuantity || !bulk.maximumQuantity)) {
                                result = this.calculatePriceFromBulk(price, bulk);
                            }
                        }
                    }
                    return result;
                },
                qtyDecrement(sku) {
                    if (this.productsQty[sku] > 0) {
                        this.productsQty[sku]--;
                    }
                },
                qtyIncrement(sku) {
                    this.productsQty[sku]++;
                },
                printForm() {
                    window.print();
                },
                resetForm() {
                    self.$overlay.show();
                    for (const sku in this.productsQty) {
                        this.productsQty[sku] = 0;
                    }
                    setTimeout(() => {
                        self.$overlay.hide()
                    }, 250);
                },
                addtocart() {
                    let addToCartItems = [];
                    for (let sku of this.productsSku) {
                        let productId = this.getProductId(sku);
                        let qty = this.productsQty[sku];
                        if (qty && qty > 0) {
                            addToCartItems.push({"productId": productId, "quantity": qty});
                        }
                    }

                    if (addToCartItems.length) {
                        fetch('/api/storefront/carts', {
                            credentials: 'same-origin',
                        }).then(function(response) {
                            return response.json();
                        }).then(function(cartReturn) {
                            var id = "";
                            var requestUrl = "";
                            if (cartReturn.length > 0) {
                                id = cartReturn[0].id;
                                requestUrl = '/api/storefront/carts/' + id + '/items';
                            } else {
                                requestUrl = '/api/storefront/carts/';
                            }

                            const lineItems = {
                                "lineItems": addToCartItems
                            };

                            fetch(requestUrl, {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: {"Content-Type": "application/json"},
                                body: JSON.stringify(lineItems)
                            }).then(function(response) {
                                return response.json();
                            }).then(function(data) {
                                if (data.id) {
                                    window.location.href = "/cart.php";
                                }
                            }).catch(error => console.error(error));
                        });
                    }
                }
            }
        }

        Vue.createApp(App).mount('#steps');
    }
}
